import { render } from "./AdRoadmap.vue?vue&type=template&id=53910291&scoped=true"
import script from "./AdRoadmap.vue?vue&type=script&lang=js"
export * from "./AdRoadmap.vue?vue&type=script&lang=js"

import "./AdRoadmap.vue?vue&type=style&index=0&id=53910291&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53910291"]])

export default __exports__